import {createFileRoute} from '@tanstack/react-router';
import {zodValidator} from '@tanstack/zod-adapter';
import {z} from 'zod';
import {AuthLoginView} from '@/features/auth/views/auth-login-view';

const searchSchema = z.object({
  returnTo: z.string().optional().default('/home'),
});

export const Route = createFileRoute('/_public/auth/login')({
  component: AuthLoginView,
  validateSearch: zodValidator(searchSchema),
});
